// @flow
import React, {Component, type ComponentType} from 'react';
import {resize} from '@homeaway/raf-optimized';

export type Size = {
    width: number,
    height: number
};

// c.f. https://github.homeawaycorp.com/ui-development/raf-optimized/blob/v1.0.9/src/index.js#L38-L44
function getClientWidth(): number {
    /* istanbul ignore next */
    return (
        window.innerWidth ||
        (document &&
            document.documentElement &&
            document.documentElement.clientWidth) ||
        (document && document.body && document.body.clientWidth) ||
        0
    );
}

function getClientHeight(): number {
    /* istanbul ignore next */
    return (
        window.innerHeight ||
        (document &&
            document.documentElement &&
            document.documentElement.clientHeight) ||
        (document && document.body && document.body.clientHeight) ||
        0
    );
}

export default function withWindowResize<Props: {onResize: (Size) => any}>(
    WrappedComponent: ComponentType<Props>
): ComponentType<Props> {
    const HAS_WINDOW = typeof window !== 'undefined';

    return class WithWindowResize extends Component<Props> {
        clearResize: Function;

        componentDidMount() {
            if (HAS_WINDOW) {
                this.clearResize = resize(this.handleResize);
                this.handleResize({
                    width: getClientWidth(),
                    height: getClientHeight()
                });
            }
        }

        componentWillUnmount() {
            this.clearResize();
        }

        handleResize = (size: Size) => {
            this.props.onResize(size);
        };

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}
